import { createFileRoute } from '@tanstack/react-router'
import { ErrorState } from '@/components/empty-state'
import { PageHeader } from '@/components/page-header'
import { Skeleton } from '@/components/ui/skeleton'
import { DocumentsForm } from '@/features/admin/documents/documents-form'
import { useSettings } from '@/features/admin/institution/api'
import { requirePermission } from '@/lib/route-guards'

export const Route = createFileRoute('/_app/admin/documents')({
  beforeLoad: requirePermission('settings:manage'),
  component: DocumentsPage,
})

/** Administración › Documentos: personalización de los PDF de la institución. */
function DocumentsPage() {
  const { data, isLoading, error, refetch } = useSettings()
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Administración"
        title="Documentos"
        description="Apariencia, datos legales y textos de contratos, recibos, planes y constancias. Lo que exige la ley no se puede quitar: solo se agrega."
      />
      {isLoading ? (
        <Skeleton className="h-96 rounded-xl" />
      ) : error || !data ? (
        <div className="rounded-xl border border-border bg-card">
          <ErrorState error={error} onRetry={() => void refetch()} />
        </div>
      ) : (
        <DocumentsForm settings={data.settings} />
      )}
    </div>
  )
}
